import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetMe } from '@/hooks/shared/useGetMe';
import Logo from '../UI/Icons/Logo';
import UserIcon from '../UI/Icons/UserIcon';
import { getFullname, getNameInitials } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import './index.scss';

export const NAV_ROUTES = t => [
  { label: t('nav_routes.dashboard'), path: APP_LINKS.dashboard },
  { label: t('nav_routes.fundraising'), path: APP_LINKS.fundraising },
  { label: t('nav_routes.funds'), path: APP_LINKS.payments },
  { label: t('nav_routes.loans'), path: APP_LINKS.loans },
  { label: t('nav_routes.personal_guarantee'), path: APP_LINKS.fpg, hideForSplitLender: true },
  // { label: t('nav_routes.founders'), path: '/founders' },
  { label: t('nav_routes.brands'), path: APP_LINKS.brands, hideForSplitLender: true },
  { label: t('nav_routes.activity'), path: APP_LINKS.activity },
  { label: t('nav_routes.reporting'), path: APP_LINKS.reporting, hideForSplitLender: true },
  { label: t('nav_routes.loan_terms'), path: APP_LINKS.loanTerms },
  // { label: t('nav_routes.faq'), path: '/help' },
];
export const Navigation = () => {
  const { user, isLender, isCombinedMode, isLoading } = useGetMe();
  const isParticipating = useSelector(state => state.fundraisingStore.isParticipating);
  const { t } = useTranslation('components');

  const isSplitLender = !isCombinedMode && isLender;
  const routes = isLoading
    ? []
    : NAV_ROUTES(t).filter(route => !isSplitLender || !route.hideForSplitLender);

  return (
    <div className="navigation__container">
      <div className="navigation__top">
        <Link to="/dashboard" className="navigation__logo">
          <Logo />
        </Link>
        <nav className="navigation">
          {routes.map(route => (
            <NavLink
              key={route.label}
              to={route.path}
              className={({ isActive }) =>
                classnames(
                  'navigation__item',
                  `navigation__item-${route.path.replace('/', '')}`,
                  isActive && 'navigation__item_active',
                )
              }
            >
              {route.label}{' '}
              {route.isNew && <span className="navigation__badge">{t('nav_routes.new')}</span>}
            </NavLink>
          ))}
        </nav>
      </div>
      {user && (
        <Link className="navigation__user" to="/profile">
          {user.photo ? (
            <div className={classnames('navigation__user-avatar', isParticipating && 'active')}>
              <img
                src={user.photo.file}
                alt={getNameInitials(user.first_name, user.last_name)}
              />
            </div>
          ) : (
            <UserIcon
              className="navigation__user-icon"
              strokeColor={isParticipating && '#FFD200'}
            />
          )}
          <div className="f-500">{getFullname(user.first_name, user.last_name, 'Profile')}</div>
        </Link>
      )}
    </div>
  );
};
